import WritingIcon from '@/assets/icon-skill-writing.svg?react';
import ResearchIcon from '@/assets/icon-skill-research.svg?react';
import AnalysisIcon from '@/assets/icon-skill-analysis.svg?react';
import CommunicationIcon from '@/assets/icon-skill-communication.svg?react';
import OtherIcon from '@/assets/icon-skill-others.svg?react';

export { OtherIcon };

export const SKILL_CATEGORY_ICONS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  Writing: WritingIcon,
  Research: ResearchIcon,
  Analysis: AnalysisIcon,
  Communication: CommunicationIcon,
  Other: OtherIcon,
};

export const PROMPT_CATEGORY_ICONS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  // add prompt icons here when ready
};
